import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StatusGraphEffects } from './status-graph.effects';
import { statusGraphReducer } from './status-graph.reducer';
import { STATUS_GRAPH_SLICE } from './status-graph.state';

@NgModule({
  imports: [
    StoreModule.forFeature(STATUS_GRAPH_SLICE, statusGraphReducer),
    EffectsModule.forFeature([StatusGraphEffects]),
  ],
})
export class StatusGraphStoreModule {}
